import request from '@/utils/request';
import { BASE_URL } from '@/utils/global';
import { requestCacheFn } from '@/utils/requestCache';

// 接口缓存2秒
function requestCache(obj: Recordable) {
  // return requestArr(obj, request, 2000);
  return requestCacheFn(obj, request, 2000);
}

// 查询品牌列表
export function queryBlandList(data: any, query: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/queryList.ac`,
    method: 'post',
    params: query,
    data,
  });
}

export function addBland(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/insert.ac`,
    method: 'post',
    data,
  });
}

export function editBland(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/update.ac`,
    method: 'post',
    data,
  });
}

export function deleteBland(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/delete.ac`,
    method: 'post',
    data,
  });
}
// 查询季节列表
export function getSeasonList(params: any, data: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/basic/season/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询波段列表
export function getRangeList(params: any, data: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/basic/ranges/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询商品分类列表
export function getCategoryList(data: any, params?: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/basic/category/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

export function addCategory(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/category/insert.ac`,
    method: 'post',
    data,
  });
}

export function editCategory(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/category/update.ac`,
    method: 'post',
    data,
  });
}

export function deleteCategory(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/category/delete.ac`,
    method: 'post',
    data,
  });
}

// 查询用户列表
export function getStaffList(data: any, params: any) {
  const requestParams = {
    url: `${BASE_URL.scmServer}/api/admin/account/user/queryList.ac`,
    method: 'post',
    data,
    params,
  };
  return requestCache(requestParams);
}

// 同步进销存仓库
export function syncFromIs() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/storehouse/syncFromIs.ac`,
    method: 'post',
  });
}

// 查询仓库列表
export function queryStoreHouseList(data: any, params?: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/basic/storehouse/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}

// 查询商品列表
export function getGoodsList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询商品列表汇总
export function getGoodsListSum(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sum.ac`,
    method: 'post',
    data,
  });
}

// 查询单品列表汇总
export function getGoodsListSumForSku(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sumForSku.ac`,
    method: 'post',
    data,
  });
}

// 查询供应商列表
export function querySupplierList(data: any) {
  return requestCache({
    url: `${BASE_URL.scmServer}/api/admin/supplier/querySupplierList.ac`,
    method: 'post',
    data,
  });
}
// 商品详情
export function goodGet(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/get.ac`,
    method: 'post',
    data,
  });
}
// 商品详情(safe会校验查看权限的二级权限)
export function goodsSafeGet(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/safeGet.ac`,
    method: 'post',
    data,
  });
}

// 新增商品
export function goodInsert(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/insert.ac`,
    method: 'post',
    data,
  });
}

// 商品编辑
export function goodUpdate(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/update.ac`,
    method: 'post',
    data,
  });
}

// 查询颜色列表
export function getColorList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/queryList.ac`,
    method: 'post',
    data,
  });
}

// 获取默认颜色
export function getColorDefault() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/getDefault.ac`,
    method: 'post',
  });
}

// 新增颜色
export function addColor(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/color/insert.ac`,
    method: 'post',
    data,
  });
}

// 获取默认尺码
export function getSizeDefault() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/size/getDefault.ac`,
    method: 'post',
  });
}

// 获取默认品牌
export function getBlandDefault() {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/bland/get/default.ac`,
    method: 'post',
  });
}

// 判断单品条码是否被占用
export function checkoutGoodsSkuBarcode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsSkuBarcode.ac`,
    method: 'post',
    data,
  });
}

// 判断商品条码是否被占用
export function checkoutGoodsBarcode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsBarcode.ac`,
    method: 'post',
    data,
  });
}

// 判断设计款的货号是否被商品占用
export function checkoutGoodsSnByDesign(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/design/checkoutGoodsSn.ac`,
    method: 'post',
    data,
  });
}

// 判断商品的货号是否被设计款占用
export function checkDesignIsUse(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkDesignIsUse.ac`,
    method: 'post',
    data,
  });
}

// 判断商品货号是否被占用
export function checkoutGoodsSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutGoodsSn.ac`,
    method: 'post',
    data,
  });
}

// 判断设计款号是否被占用
export function checkoutDesignSn(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutDesignSn.ac`,
    method: 'post',
    data,
  });
}

// 判断商品单品编码是否被占用
export function checkoutSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkoutSkuCode.ac`,
    method: 'post',
    data,
  });
}

// 查询物料分类列表
export function getMaterialCategoryList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/material/category/getList.ac`,
    method: 'post',
    data,
  });
}

// 获取物料列表
export function getMaterialList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/material/getMaterialList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 查询生产节点模板列表
export function queryProductionNodeTemplateList(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/workProcessTemplate/queryList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 获取生产节点模板详情
export function getProductionNodeTpDetail(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/workProcessTemplate/get.ac`,
    method: 'post',
    data,
  });
}

// 批量获取工序单价(没校验权限)
export function batchGetWorkProcessPrice(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/workProcess/getPrice.ac`,
    method: 'post',
    data,
  });
}

// 查询尺码列表
export function getSizeList(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/basic/size/queryList.ac`,
    method: 'post',
    data,
  });
}

// 删除商品
export function deleteGood(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/delete.ac`,
    method: 'post',
    data,
  });
}

// 查询库存流水列表
export function queryGoodsStoredRecords(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/stored/queryGoodsStoredRecords.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多商品导入
export function importMultiGoods(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/importGoods.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多商品导入修改
export function importEditGoods(data: any, params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/importEditGoods.ac`,
    method: 'post',
    data,
    params,
  });
}

// 多商品导出
export function getImportEditGoodsExportData(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/getImportEditGoodsExportData.ac`,
    method: 'post',
    data,
  });
}

// 查询单品列表
export function querySingleGoodsRecords(params: any, data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sku/selectGoodsSkuList.ac`,
    method: 'post',
    params,
    data,
  });
}

// 快捷修改商品成本价
export function updateGoodsCostPrice(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/updateGoodsCostPrice.ac`,
    method: 'post',
    data,
  });
}
// 获取商品是否被使用
export function getGoodsIsUse(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/isUse.ac`,
    method: 'post',
    params,
  });
}
// 商品同步进销存
export function syncGoodsImport(params: any, data: any = {}) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/syncGoodsImport.ac`,
    method: 'post',
    params,
    data,
  });
}

// 商品物料清单bom锁定/解锁
export function editBomStateByGoods(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/editBomState.ac`,
    method: 'post',
    data,
  });
}

// 版单物料清单bom锁定/解锁
export function editBomFinishByGoods(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/editBomFinish.ac`,
    method: 'post',
    data,
  });
}

// 封样

export function sealedSample(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sealedSample.ac`,
    method: 'post',
    params,
  });
}
// 取消封样

export function sealedSampleCancel(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/sealedSampleCancel.ac`,
    method: 'post',
    params,
  });
}
// 判断商品是否存在未结束的生产单

export function hasNotFinishProduce(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/order/produce/hasNotFinish.ac`,
    method: 'post',
    params,
  });
}

// 初始化单品编码
export function initGoodsSkuCode(params: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/initSkuCode.ac?goodsId=${params.goodsId}`,
    method: 'post',
  });
}

// 查询IE核价日志操作列表
export function queryGoodIeOperateRecordList(data: any, query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/pageIeOperateRecord.ac`,
    method: 'post',
    data,
    params: query,
  });
}

// 获取IE核价日志操作详情
export function getGoodIeOperateRecordInfo(query: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/getIeOperateRecordInfo.ac?recordId=${query.recordId}`,
    method: 'post',
  });
}

// 检查商品单品是否已被使用
export function checkSkuIsUsed(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/checkSkuIsUsed.ac`,
    method: 'post',
    data,
  });
}

// 自动生成商品单品编码
export function authGenerateSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/authGenerateSkuCode.ac`,
    method: 'post',
    data,
  });
}

// 自动生成商品单品编码
export function generateSkuCode(data: any) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/skuCode/generateSkuCode.ac`,
    method: 'post',
    data,
  });
}

// 匹配绑定进销存
export function blandToBindingIs(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/is/company/brand/add.ac`,
    method: 'post',
    data,
  });
}
// 进销存账号列表
export function isBindingCompanyList(params: Recordable, data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/is/company/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}
// 新增进销存账号
export function addIsBindingCompany(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/is/company/addIsBindingCompany.ac`,
    method: 'post',
    data,
  });
}
// 删除进销存账号
export function deleteIsBindingCompany(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/is/company/delete.ac`,
    method: 'post',
    data,
  });
}
// 保存bom模板
export function saveBomTemplate(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/bom/template/save.ac`,
    method: 'post',
    data,
  });
}
// 删除bom模板列表
export function batchDeleteBomTemplate(data: number[]) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/bom/template/delete.ac`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    data,
  });
}
// 获取bom模板列表
export function getBomTemplateList(data: Recordable, params: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/bom/template/queryList.ac`,
    method: 'post',
    data,
    params,
  });
}
// 获取bom模板
export function queryBomTemplateById(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/bom/template/queryByBomId.ac`,
    method: 'post',
    data,
  });
}

// 工序模板工序名称列表
export function queryWorkProcessNameDistinceList(data: Recordable) {
  return request({
    url: `${BASE_URL.scmServer}/api/admin/goods/workProcessTemplate/listWorkProcessNameDistinct.ac`,
    method: 'post',
    data,
  });
}
